import { render, staticRenderFns } from "./sendResource.vue?vue&type=template&id=14863961&scoped=true&"
import script from "./sendResource.vue?vue&type=script&lang=js&"
export * from "./sendResource.vue?vue&type=script&lang=js&"
import style0 from "./sendResource.vue?vue&type=style&index=0&id=14863961&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14863961",
  null
  
)

export default component.exports